import { AxiosResponse } from "axios";
import API from "../api";
import { NotificationTemplate } from "../models/notification.template";
import BaseService from "./_base.service";

const endpoint = "communication-centre";

interface SendTemplatePayload extends NotificationTemplate {
  notificationType: 'email' | 'sms' | 'push';
  notificationItem: {
    id: number;
    type: 'Order' | 'Shipment' | 'Quote' | 'Invoice';
  };
}

const CommunicationCentreService = {
  ...BaseService<NotificationTemplate>({ endpoint }),
  async validateTemplateName(templateName: string, companyId: number, id?: number): Promise<AxiosResponse<{ valid: boolean }>> {
    return await API.get(`/${endpoint}/validate-template-name`, { params: { templateName, companyId, id } });
  },
  async sendTemplate(payload: SendTemplatePayload): Promise<AxiosResponse<any>> {
    return await API.post('/notification/template/send', payload);
  },
  async getAvailableUsersForPush(id: number, type: 'Order' | 'Shipment' | 'Quote' | 'Invoice'): Promise<AxiosResponse<Array<{ id: number, fullName: string }>>> {
    return await API.get('/notification/template/push/available-users', { 
      params: { id, type } 
    });
  },
};

export default CommunicationCentreService;
